export default __webpack_public_path__ + "static/media/animation-arrow10.4a79a046.gif";